import { render, staticRenderFns } from "./ReservationsBookingHistory.vue?vue&type=template&id=3b3bb06e"
import script from "./ReservationsBookingHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservationsBookingHistory.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports